<div class="modal-header" appCustomAutofocus>
    <h3>Timecard Item Attachments</h3>
</div>
<div class="modal-body">
    <div class="col-md-12">
        <div *ngIf="alert != null" class="alert" [ngClass]="{'alert-success' : alert.type === 'success', 'alert-default' : alert.type === 'default', 'alert-danger': alert.type === 'danger' }" role="alert">
            {{alert.msg}}
            <button type="button" class="close" (click)="closeAlert()">
                <i class="modus-icons">close</i>
            </button>
        </div>
        <div class="alert alert-warning" *ngIf="uniqueAttchID == null && savedFiles.length > 0">Please refresh the page if you wish to delete saved attachments.</div>
    </div>
    <label *ngIf="savedFiles?.length > 0"><strong>Attachments</strong></label>
    <div *ngIf="savedFiles?.length > 0">
        <div *ngFor="let file of savedFiles" style="margin-bottom: 15px;">
            <a href="/Document/GetVPAttachment?attachmentID={{file.AttachmentID}}"> {{file.Description}}</a>
            <button class="btn btn-icon-only btn-danger float-right" (click)="deleteSavedAttachment(file)" *ngIf="uniqueAttchID != null && !reviewModal && !readOnly">
                <i class="modus-icons">trash</i>
            </button>
        </div>
    </div>
    <label *ngIf="row.newFiles?.length > 0"><strong>The following items will be uploaded when the timecard is saved:</strong></label>
    <br *ngIf="row.newFiles?.length > 0" />
    <div *ngFor="let file of row.newFiles" style="margin-top: 20px">
        {{file.Filename}}
        <button class="btn btn-icon-only btn-danger" (click)="deleteUnsavedAttachment(file)" *ngIf="file.File != null && file.Progress == null">
            <i class="modus-icons">trash</i>
        </button>
        <div style="padding-left:15px;margin-top:5px;">
            <div class="progress" style="width:250px;" *ngIf="file.Progress > 0">
                <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': file.Progress + '%' }">{{file.Progress}}%</div>
            </div>
        </div>
    </div>
    <div id="fileDrop"
         *ngIf="!readOnly"
         style="cursor:pointer;"
         ngfDrop
         multiple="1"
         selectable="1"
         [(validDrag)]="validComboDrag"
         [(files)]="formData.fileDrop"
         accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx"
         [(dragFiles)]="dragFiles"
         class="drop-box"
         [class.invalid-drag]="validComboDrag===false"
         [class.valid-drag]="validComboDrag"
         (filesChange)="upload()" [ngfFixOrientation]="false">
        Drop a file or Click to upload
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">OK</button>
</div>